module.exports = __webpack_public_path__ + "static/media/Web-application-support.f0f01731.png";